import { api } from "@api/api";
import { Banner } from "@modules/banners/types";
import { BannerFormValues } from "@modules/banners/validations";

export async function createBannerService(data: BannerFormValues): Promise<Banner> {
  const { image, image_mobile, ...body } = data;

  const { data: banner } = await api.post<Banner>("v1/banner_admin/", body);

  if (image && image instanceof File || image_mobile && image_mobile instanceof File) {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("image_mobile", image_mobile);

    await api.patch(`v1/banner_admin/${banner.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return banner;
}
